import { Injectable } from '@angular/core';

// **************************************************************************
// APP CACHE SERVICE
// Forces the browser to drop the cached frontend build so the next load
// fetches the newly released one.
// **************************************************************************

@Injectable({ providedIn: 'root' })
export class AppCacheService {

    /**
     * Empties Cache Storage and unregisters service workers.
     * Never throws - a browser that blocks or lacks these APIs just keeps its cache.
     */
    public async clear(): Promise<void> {
        await Promise.all([
            this.clearCacheStorage(),
            this.unregisterServiceWorkers(),
        ]);
    }

    /** Reloads the application. Call after clear() so the new build is fetched. */
    public reload(): void {
        window.location.reload();
    }

    // =========================================================================
    // PRIVATE METHODS
    // =========================================================================
    private async clearCacheStorage(): Promise<void> {
        if (!('caches' in window)) return;

        try {
            const keys = await caches.keys();
            await Promise.all(keys.map(key => caches.delete(key)));
        } catch {
            // Cache Storage unavailable (private mode, blocked site data) - ignore
        }
    }

    private async unregisterServiceWorkers(): Promise<void> {
        if (!('serviceWorker' in navigator)) return;

        try {
            const registrations = await navigator.serviceWorker.getRegistrations();
            await Promise.all(registrations.map(registration => registration.unregister()));
        } catch {
            // Service workers unavailable or blocked - ignore
        }
    }
}
